import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "@/data/siteContent";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function WhoWeAre() {
  return (
    <section id="about" data-testid="who-we-are-section" className="relative py-24 md:py-32 bg-white">
      <div className="container-prose">
        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          className="eyebrow mb-5"
        >
          — Who We Are
        </motion.p>

        <div className="grid md:grid-cols-5 gap-0 md:gap-10 rounded-sm overflow-hidden">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            variants={fadeUp}
            custom={1}
            className="md:col-span-2 relative bg-navy text-white p-10 md:p-14 overflow-hidden"
          >
            <div
              className="absolute inset-0 opacity-15 bg-cover bg-center"
              style={{ backgroundImage: `url(${ASSETS.whoWeAreBg})` }}
              aria-hidden
            />
            <div className="absolute inset-0 bg-gradient-to-br from-navy via-navy/95 to-navy-dark" aria-hidden />
            <div className="relative">
              <svg className="text-gold w-14 h-14 mb-6" viewBox="0 0 32 32" fill="currentColor" aria-hidden>
                <path d="M10 8C5 8 2 12 2 17v7h10V14H7c0-3 2-5 5-5l-2-1zM24 8c-5 0-8 4-8 9v7h10V14h-5c0-3 2-5 5-5l-2-1z" />
              </svg>
              <blockquote
                data-testid="who-we-are-pullquote"
                className="font-serif text-gold text-2xl md:text-3xl lg:text-[2rem] leading-snug italic"
              >
                The difference between a good application and a great one? Knowing your story — and knowing how to tell it.
              </blockquote>
              <p className="mt-6 font-serif text-white/80 text-lg">— The AceMax Way.</p>
              <div className="gold-rule w-24 mt-10" />
            </div>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            variants={fadeUp}
            custom={2}
            className="md:col-span-3 bg-[#FAFAF7] p-10 md:p-14"
          >
            <h2 className="font-serif text-navy text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight">
              Born from friendship.<br />
              <span className="italic text-navy/70">Built with purpose.</span>
            </h2>
            <div className="mt-8 space-y-5 text-navy-deeper/80 text-base md:text-lg leading-relaxed font-sans">
              <p>
                AceMax was born from friendship and a shared purpose. Co-founders{" "}
                <span className="font-semibold text-navy">Garvita Dutta</span> and{" "}
                <span className="font-semibold text-navy">Grisham Sofat</span> combined their global
                expertise to build what the industry was missing: a consulting firm that truly puts
                students first.
              </p>
              <p>
                As a young, women-founded firm, we bring not just strategy and experience — but
                heart. Every family that walks through our doors receives the same attention we
                would give our own.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-6">
              {[
                ["Countries", "15+"],
                ["Top-50 Placements", "40+"],
              ].map(([label, value]) => (
                <div key={label} className="border-t border-navy/10 pt-4">
                  <div className="font-serif text-3xl md:text-4xl text-navy">{value}</div>
                  <div className="text-xs uppercase tracking-widest text-navy/60 mt-1">{label}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
